import { FILTERS_OPERATORS } from '../../shared/constants'

const CUSTOM_OPERATOR = 'CUSTOM_OPERATOR'

const FILTERS_OPERATORS_LABELS = {
  [FILTERS_OPERATORS.ALL]: 'All',
  [FILTERS_OPERATORS.LESS_EQUAL]: '≤ Less than or equal to',
  [FILTERS_OPERATORS.GREATER_EQUAL]: '≥ Greater than or equal to',
  [FILTERS_OPERATORS.BETWEEN]: 'Between',
}

export { FILTERS_OPERATORS, FILTERS_OPERATORS_LABELS, CUSTOM_OPERATOR }
